module.exports = __webpack_public_path__ + "img/icon_payment_mastercard.9d254487.svg";